import { useCreatePath, useRecordContext } from 'react-admin';
import { useRegisterBreadcrumb } from '../layout/navbar/BreadcrumbsManager';
import { IAPIKey } from '../../utilities/schemas/apiKey';
import resourceNames from '../../constants/resourceNames';

const ApiKeyBreadcrumb = () => {
  const record = useRecordContext<IAPIKey>();
  const createPath = useCreatePath();
  const path = createPath({ resource: resourceNames.API_KEYS, type: 'edit', id: record?.id });
  useRegisterBreadcrumb({
    title: record?.clientId,
    path,
  });

  return null;
};

export default ApiKeyBreadcrumb;
